/**
 * BackgroundEffects Component
 * Animated gradient orbs and grid background
 * Pure presentational component - no props needed
 */
const BackgroundEffects = () => {
  return (
    <div className="psyber-bg-effects">
      <div className="psyber-orb psyber-orb-1"></div>
      <div className="psyber-orb psyber-orb-2"></div>
      <div className="psyber-bg-grid"></div>
    </div>
  )
}

export default BackgroundEffects
